import {
  Grid2,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import styles from "./DomainTable.module.scss";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

const DomainTable = (props) => {
  const { addNewDomain, rows, addDomain, length } = props;

  const showStatus =
    rows.length > 0 && rows.some((item) => item.status != null);

  return (
    <Grid2>
      <TableContainer className={styles.main}>
        {length === 5 ? (
          ""
        ) : (
          <Grid2 className={styles.header}>
            <Grid2 className={styles.header1} onClick={addDomain}>
              {addNewDomain}
            </Grid2>
          </Grid2>
        )}

        <Table>
          <TableHead className={styles.tableHead}>
            <TableRow className={styles.tablerow}>
              <TableCell className={styles.tableHeaderText}>
                Domain Name
              </TableCell>
              <TableCell className={styles.tableHeaderText}>DNS</TableCell>
              <TableCell className={styles.tableHeaderText}>SSL</TableCell>
              <TableCell className={styles.tableHeaderText}>
                SSL Expiration
              </TableCell>
              <TableCell className={styles.tableHeaderText}>Primary</TableCell>
              {/* {showStatus && (
                <TableCell className={styles.tableHeaderText}>Status</TableCell>
              )} */}
              <TableCell className={styles.tableHeaderText}>Delete</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((item, index) =>
              item.isInProgress ? (
                <TableRow key={index} className={styles.skeletonRow}>
                  <TableCell className={styles.tableBodyText}>
                    <div className={styles.domainInProgress}>
                      <span className={styles.domainName}>{item.domain}</span>
                      <span className={styles.goingLiveBadge}>
                        <span className={styles.dot} />
                        Going Live
                      </span>
                    </div>
                  </TableCell>
                  <TableCell className={styles.tableBodyText}>
                    <Skeleton variant="rounded" width={90} height={28} />
                  </TableCell>
                  <TableCell className={styles.tableBodyText}>
                    <Skeleton variant="rounded" width={90} height={28} />
                  </TableCell>
                  <TableCell className={styles.tableBodyText}>
                    <Skeleton variant="text" width={60} height={24} />
                  </TableCell>
                  <TableCell className={styles.tableBodyText}>
                    <Skeleton variant="rounded" width={70} height={30} />
                  </TableCell>
                  {/* {showStatus && (
                    <TableCell className={styles.tableBodyText}>
                      {item.status}
                    </TableCell>
                  )} */}
                  <TableCell className={styles.borderbottom}>
                    {/* {item.delete ? (
                      <Grid2 className={styles.delete} onClick={item.delete}>
                        <DeleteOutlinedIcon className={styles.deleteIcon} />
                      </Grid2>
                    ) : (
                      ""
                    )} */}
                    <Skeleton variant="rounded" width={20} height={20} />
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow key={index}>
                  <TableCell className={styles.tableBodyText}>
                    {item.domain}
                  </TableCell>
                  <TableCell className={styles.tableBodyText}>
                    {item.DNS}
                  </TableCell>
                  <TableCell className={styles.tableBodyText}>
                    {item.SSL}
                  </TableCell>
                  <TableCell className={styles.tableBodyText}>
                    {item.SSLExpiration}
                  </TableCell>
                  <TableCell className={styles.tableBodyText}>
                    {item.primary}
                  </TableCell>
                  {/* {showStatus && (
                    <TableCell className={styles.tableBodyText}>
                      {item.status}
                    </TableCell>
                  )} */}
                  <TableCell className={styles.borderbottom}>
                    {item.delete ? (
                      <Grid2 className={styles.delete} onClick={item.delete}>
                        <DeleteOutlinedIcon className={styles.deleteIcon} />
                      </Grid2>
                    ) : (
                      ""
                    )}
                  </TableCell>
                </TableRow>
              ),
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid2>
  );
};

export default DomainTable;
